import certificate_1 from '../img/certificates/certificate_1.jpg';
import certificate_2 from '../img/certificates/certificate_2.jpg';
import certificate_3 from '../img/certificates/certificate_3.jpg';
import certificate_4 from '../img/certificates/certificate_4.jpg';
import certificate_5 from '../img/certificates/certificate_5.png';
import certificate_6 from '../img/certificates/certificate_6.jpg';
import certificate_7 from '../img/certificates/certificate_7.jpeg';
import certificate_8 from '../img/certificates/certificate_8.jpg';

const certificates = [
  {
    id: 1,
    title: 'Bachelor Degree in IT',
    date: 'October 03, 2022',
    image: certificate_8,
    text: 'Bachelor Degree in IT at IPCB Escola Superior de Tecnologia',
  },
  {
    id: 2,
    title: 'Google App Script Complete Course Beginner to Advanced',
    date: 'April 26, 2023',
    image: certificate_6,
    text: 'Online course in Google App Script',
  },
  {
    id: 3,
    title: 'Java Programming Complete Beginner to Advanced',
    date: 'March 09, 2023',
    image: certificate_7,
    text: 'Online course in Java',
  },
  {
    id: 4,
    title: 'CTeSP - Curso de Desenvolvimento de Produto e Multimédia',
    date: 'July 27, 2018',
    image: certificate_1,
    text: 'Degree in Development of products and multimedia',
  },
  {
    id: 5,
    title: 'IEFP - OutSystems',
    date: 'October 12, 2019',
    image: certificate_2,
    text: 'Intership at EmbraceRAD company using Oustystems',
  },
  {
    id: 6,
    title: 'CodeIgniter4',
    date: 'May 12, 2021',
    image: certificate_3,
    text: 'Creation of a Publication website with CodeIgniter4 PHP framework',
  },
  {
    id: 7,
    title: 'Figma',
    date: 'February 04, 2022',
    image: certificate_4,
    text: 'Online course using Figma',
  },
  {
    id: 8,
    title: 'Demola',
    date: 'May 28, 2021',
    image: certificate_5,
    text: 'Co-Creation Team, Development od ideias an prototypes to improve the communication between the city and the citizens',
  },
];

export default certificates;
